/**
 * Save version chain. Every schema bump adds a migration function and a
 * frozen fixture in test/fixtures asserting the chain output validates.
 */
import { SAVE_VERSION, validateSave, type SaveV1 } from './schema';

type Migration = (save: Record<string, unknown>) => Record<string, unknown>;

/** keyed by the version they migrate FROM */
const MIGRATIONS: Record<number, Migration> = {
  // 1: (save) => ({ ...save, version: 2, newField: default }),
};

export function migrateSave(raw: unknown): SaveV1 | null {
  if (typeof raw !== 'object' || raw === null) return null;
  let save = raw as Record<string, unknown>;
  let guard = 0;
  while (
    typeof save.version === 'number' &&
    save.version < SAVE_VERSION &&
    guard++ < 16
  ) {
    const step = MIGRATIONS[save.version];
    if (!step) return null;
    save = step(save);
  }
  return validateSave(save);
}
